import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.2, 0.8, 0.2, 1] },
};

export function Section({ children, className = "", id, testId }) {
  return (
    <section
      id={id}
      data-testid={testId}
      className={`relative px-6 md:px-12 lg:px-16 py-24 md:py-32 ${className}`}
    >
      {children}
    </section>
  );
}

export function SectionHeader({ overline, title, intro, align = "left", testId }) {
  return (
    <div
      data-testid={testId}
      className={`max-w-4xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <motion.p {...fadeUp} className="overline mb-6">{overline}</motion.p>}
      <motion.h2
        {...fadeUp}
        transition={{ ...fadeUp.transition, delay: 0.05 }}
        className="section-title text-4xl md:text-5xl lg:text-6xl text-white text-balance"
      >
        {title}
      </motion.h2>
      {intro && (
        <motion.p
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.1 }}
          className="mt-6 text-zinc-400 text-base md:text-lg max-w-2xl leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  );
}

export function PageHero({ overline, title, intro, testId }) {
  return (
    <section
      data-testid={testId}
      className="relative px-6 md:px-12 lg:px-16 pt-24 md:pt-32 lg:pt-40 pb-20 md:pb-28 border-b border-white/5"
    >
      <div className="max-w-6xl">
        {overline && (
          <motion.p {...fadeUp} className="overline mb-6">
            {overline}
          </motion.p>
        )}
        <motion.h1
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.05 }}
          className="font-serif-display font-light text-white text-5xl md:text-7xl lg:text-[88px] leading-[1.05] tracking-tight text-balance"
          style={{ letterSpacing: "-0.025em" }}
        >
          {title}
        </motion.h1>
        {intro && (
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="mt-8 text-zinc-400 text-lg md:text-xl max-w-2xl leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
}
